import React from "react";
import { Link } from "react-router-dom";

const Work = () => {
    return (
        <div className="container">
            <div className="nav-left">
                <div className="nav-left-item">
                    <Link to="/" className="nav-left-link">
                        HOME
                    </Link>
                </div>
                <div className="nav-line"></div>
                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>

            <div className="wrapper w-clearfix wf-selection">
                <div className="section-left">
                    <div className="content content-main">
                        <div className="header-mask">
                            <h1 className="header swipe-up">WORK</h1>
                        </div>
                        <div className="description-mask">
                            <p className="description">
                                These are some of my independent projects that
                                showcase my skills in web development.
                                <br />
                            </p>
                        </div>
                        <div className="description-mask">
                            <p className="description">
                                I utilized React.js / Next.js , Node.js, and
                                PostgreSQL to build these projects,
                                demonstrating my proficiency in creating
                                scalable and dynamic web applications.
                                <br />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section-right section-long">
                    <div className="w-dyn-list">
                        <div role="list" className="nav w-dyn-items">
                            <div role="listitem" class="nav-item w-dyn-item">
                                <Link to="/work/store-app" class="nav-link">
                                    Store app
                                </Link>
                                <br />
                                <h1 class="header header-small">
                                    Full-stack responsive E-commerce app using
                                    Next.js, Stripe, Sanity.io.
                                </h1>
                            </div>
                        </div>
                        <div role="list" className="nav w-dyn-items">
                            <div role="listitem" class="nav-item w-dyn-item">
                                <Link to="/work/Miko" class="nav-link">
                                    Miko
                                </Link>
                                <br />
                                <h1 class="header header-small">
                                    Fully responsive Website for Miko
                                    Gebäudereinigung Weinstadt
                                </h1>
                            </div>
                        </div>
                        <div role="list" className="nav w-dyn-items">
                            <div role="listitem" class="nav-item w-dyn-item">
                                <Link to="/work/media" class="nav-link">
                                    Sike Movies
                                </Link>
                                <br />
                                <h1 class="header header-small">
                                    Next.js Application fetching data from
                                    TheMovieDB.
                                </h1>
                            </div>
                        </div>
                        <div role="list" className="nav w-dyn-items">
                            <div role="listitem" class="nav-item w-dyn-item">
                                <Link to="/work/painting" class="nav-link">
                                    Sip Und Paint
                                </Link>
                                <br />
                                <h1 class="header header-small">
                                    Painting Services Website with React and
                                    Firebase Contact Form
                                </h1>
                            </div>
                        </div>
                        <div role="list" className="nav w-dyn-items">
                            <div role="listitem" class="nav-item w-dyn-item">
                                <Link to="/work/todo" class="nav-link">
                                    To-Do
                                </Link>
                                <br />
                                <h1 class="header header-small">To-Do List</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Work;
